import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UiKitModule } from '@serviceplan/ui-kit';
// eslint-disable-next-line  @nx/enforce-module-boundaries
import { AssetViewTypeService } from '@thehubz/client/assets-module';
import { AssetUIModel, FilterFormDataModel, FilterTab, ViewType } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { JackpotModalComponent } from '../jackpot-modal/jackpot-modal.component';
import { FilterFormData } from './data/filter-form-data';
import { MenuSettingsData } from './data/menu-settings-data';

@Component({
  selector: 'wl-jackpot-assets-actions',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatCheckboxModule, MatTooltipModule, MatMenuModule, UiKitModule, MatTabsModule, JackpotModalComponent],
  templateUrl: './jackpot-assets-actions.component.html',
  styleUrls: ['./jackpot-assets-actions.component.scss'],
})
export class JackpotAssetsActionsComponent implements OnInit, OnChanges {
  @Input() gridSettingsKeySuffix = '';
  @Input() assetCount!: number;
  @Input() assets: AssetUIModel[] = [];
  @Input() sortByNew!: boolean;
  @Input() selectedViewSection2!: ViewType;
  @Input() selectedTabKey!: string;
  @Input() searchText = '';
  @Input() appliedFilters!: number;

  @Output() sortBy = new EventEmitter<AnyType>();
  @Output() changeView = new EventEmitter<ViewType>();
  @Output() tabSelected = new EventEmitter<AnyType>();
  @Output() searchTextChanged = new EventEmitter<AnyType>();
  @Output() clearSearch = new EventEmitter<AnyType>();
  @Output() applyFilters = new EventEmitter<AnyType>();

  searchPlaceholder = 'Assets suchen..';
  isMobileSearchOpen = false;
  assetGalleryMenuObject = MenuSettingsData.ASSET_GALLERY_MENU_SETTINGS;

  filterTab: FilterTab = {
    key: '',
    text: '',
    selectKey: '',
    filterId: '',
    visible: true,
    tabMenu: false,
    tabType: 'default',
    count: 0,
  };
  filterTabs: FilterTab[] = [
    {
      key: 'assets',
      text: 'Alle Assets',
      visible: true,
      filterId: 'all_assets_0',
      selectKey: 'all_assets',
      tabMenu: false,
      tabType: 'default',
      count: 0,
    },
  ];

  jackpotExpiryDate = '';
  warning = '';

  filterAssetFormData!: FilterFormDataModel;
  selectedFilterObject: AnyType;

  filterOptionsObject: AnyType;

  constructor(protected assetViewTypeService: AssetViewTypeService) {}

  ngOnInit(): void {
    this.setFilterForm();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assets']?.currentValue) {
      this.setFilterForm();
    }
  }

  setFilterForm() {
    this.filterAssetFormData = FilterFormData.FORM_DATA;
    const formats = [...new Set(this.assets.map((asset) => asset['metadata'].ext))];
    const assetMediums = [...new Set(this.assets.map((asset) => asset['metadata'].assetMedium))];
    const assetTypes = [...new Set(this.assets.map((asset) => asset.assetType))];
    const formatField = this.filterAssetFormData.formFields?.find((field) => field.formFieldName === 'formatType');
    const assetTypeField = this.filterAssetFormData.formFields?.find((field) => field.formFieldName === 'assetType');
    const mediumField = this.filterAssetFormData.formFields?.find((field) => field.formFieldName === 'mediumType');

    if (formatField?.options.length === 0) {
      formatField.options = formats;
      if (formats.length === 1) {
        formatField.multiple = false;
      }
    }
    if (assetTypeField?.options.length === 0) {
      assetTypeField.options = assetTypes;
      if (assetTypes.length === 1) {
        assetTypeField.multiple = false;
      }
    }
    if (mediumField?.options.length === 0) {
      mediumField.options = assetMediums;
      if (assetMediums.length === 1) {
        mediumField.multiple = false;
      }
    }

    this.filterOptionsObject = {
      formats: formats,
      assetMediums: assetMediums,
      assetTypes: assetTypes,
    };
    this.initTabs();
  }
  initTabs() {
    const assetTypes = this.filterOptionsObject.assetTypes;
    this.filterTabs[0].count = this.assets.length;
    for (let i = 0; i < assetTypes.length; i++) {
      const tempFilterTab = { ...this.filterTab };
      tempFilterTab.key = assetTypes[i].toLowerCase();
      tempFilterTab.filterId = assetTypes[i].toLowerCase() + '-' + i;
      tempFilterTab.selectKey = assetTypes[i];
      tempFilterTab.text = assetTypes[i];
      tempFilterTab.count = this.assets.filter((asset) => asset.assetType === assetTypes[i]).length;
      const tabIndex = this.filterTabs.findIndex((tab) => tab.key === tempFilterTab.key);
      if (tabIndex === -1) {
        this.filterTabs.push(tempFilterTab);
      } else {
        this.filterTabs[tabIndex].count = tempFilterTab.count;
      }
    }
  }

  filterAssets(event: AnyType) {
    if (event) {
      this.selectedFilterObject = event;
      this.applyFilters.emit(event);
    } else {
      this.resetFilter();
    }
  }

  resetFilter() {
    this.appliedFilters = 0;
    this.selectedFilterObject = {};
    this.applyFilters.emit();
  }

  toggleMobileSearch() {
    this.isMobileSearchOpen = !this.isMobileSearchOpen;
    if (!this.isMobileSearchOpen) {
      this.searchText = '';
    }
  }
  onEvent() {
    this.isMobileSearchOpen = false;
    this.searchText = '';
  }
}
